import { render, staticRenderFns } from "./userLayout.vue?vue&type=template&id=0160c37a&scoped=true"
import script from "./userLayout.vue?vue&type=script&lang=js"
export * from "./userLayout.vue?vue&type=script&lang=js"
import style0 from "./userLayout.vue?vue&type=style&index=0&id=0160c37a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160c37a",
  null
  
)

export default component.exports